import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up fsd",
  role: "dialog",
  "aria-label": "Team suggestion in the Forge"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "fsd-quote"
}
const _hoisted_5 = { class: "fsd-meta" }
const _hoisted_6 = {
  key: 1,
  class: "fsd-loading",
  role: "status"
}
const _hoisted_7 = {
  key: 2,
  class: "fsd-error",
  role: "alert"
}
const _hoisted_8 = {
  key: 0,
  class: "fsd-warn"
}
const _hoisted_9 = {
  key: 1,
  class: "fsd-warn"
}
const _hoisted_10 = {
  key: 2,
  class: "fsd-hint"
}
const _hoisted_11 = { class: "fsd-check" }
const _hoisted_12 = {
  key: 3,
  class: "fsd-hint"
}
const _hoisted_13 = { class: "fsd-actions" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_forge_compare = _resolveComponent("forge-compare")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "fsd-close",
        title: "Close",
        disabled: _ctx.busy,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, "×", 8, _hoisted_3),
      _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Suggestion in the Forge", -1)),
      (_ctx.view)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createTextVNode("From ", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.view.user || 'a team member'), 1),
              (_ctx.view.date)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · " + _toDisplayString(_ctx.dateLabel(_ctx.view.date)), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _cache[6] || (_cache[6] = _createTextVNode(" · on ", -1)),
              _createVNode(_component_router_link, {
                to: '/playbook/' + _ctx.view.slug,
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.view.nodeName), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.view.suggestion), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.phase == 'loading')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "fsd-orb" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.loadingText), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      (_ctx.phase == 'review' && _ctx.view && _ctx.view.draft)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (_ctx.view.stale)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "The process has changed since the Forge drafted this. Draft again to work from the current version."))
              : (_ctx.view.draftPending)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "This process already has a draft waiting for approval. Saving puts this change on top of it."))
                : _createCommentVNode("", true),
            (_ctx.nameChanged)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createTextVNode("Suggested new name: \"" + _toDisplayString(_ctx.view.draft.name) + "\" ", 1),
                  _createElementVNode("label", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keepName) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.keepName]
                    ]),
                    _createTextVNode(" keep \"" + _toDisplayString(_ctx.view.nodeName) + "\"", 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_forge_compare, {
              current: _ctx.view.current,
              draft: _ctx.view.draft.items,
              changes: _ctx.view.draft.changesSummary,
              "draft-label": "With the suggestion",
              "changes-label": "What changes"
            }, null, 8, ["current", "draft", "changes"]),
            (!_ctx.view.draft.changesSummary.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, "The Forge made no changes."))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          type: "button",
          class: "ai-btn ai-btn-ghost",
          disabled: _ctx.busy,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismiss()))
        }, "Dismiss from the Forge", 8, _hoisted_14),
        _cache[8] || (_cache[8] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
        (_ctx.phase != 'loading')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ai-btn ai-btn-ghost",
              disabled: _ctx.busy,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.draft()))
            }, _toDisplayString(_ctx.view && _ctx.view.draft ? 'Draft again' : 'Draft with the Forge'), 9, _hoisted_15))
          : _createCommentVNode("", true),
        (_ctx.phase == 'review' && _ctx.view && _ctx.view.draft)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "ai-btn",
              disabled: _ctx.busy || !_ctx.view.draft.changesSummary.length && !_ctx.nameChanged,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save()))
            }, _toDisplayString(_ctx.saving ? 'Saving…' : 'Save as Draft for Approval'), 9, _hoisted_16))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}